export const MOBILE_KEYBOARD_HEIGHT_THRESHOLD = 120;

export function didViewportRevealKeyboard(baselineHeight, currentHeight) {
  return Boolean(
    baselineHeight
    && currentHeight
    && baselineHeight - currentHeight >= MOBILE_KEYBOARD_HEIGHT_THRESHOLD
  );
}

export function shouldReloadAfterKeyboardLogin({ keyboardOpened, userAgent, isSingleColumn }) {
  return Boolean(
    keyboardOpened
    && isSingleColumn
    && /CriOS/i.test(userAgent || '')
  );
}
